export enum IAuthorizationMechanism {
  public = 'PUBLIC',
  authorized_only = 'AUTHORIZED_ONLY',
  requires_identification = 'REQUIRES_IDENTIFICATION',
}
